import {RECAPTCHA_KEY, CAPTCHA_LOCAL_SECRET} from "data/constants";

export const getToken = async (): Promise<string> => {
	if (CAPTCHA_LOCAL_SECRET) {
		return Promise.resolve(CAPTCHA_LOCAL_SECRET);
	}

	try {
		if (!window.grecaptcha) {
			throw new Error("reCAPTCHA not loaded");
		}

		await new Promise<void>((resolve) => window.grecaptcha.ready(resolve));
		return window.grecaptcha.execute(RECAPTCHA_KEY, {action: "submit"});
	} catch (e) {
		console.log(e);
		return Promise.reject(e);
	}
};
